<div class="loading" [ngStyle]="{ 'height': height }">
    <mat-progress-spinner mode="indeterminate" [diameter]="diameter"></mat-progress-spinner>
    <p *ngIf="message">{{ message }}</p>
</div>
